/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Claimant_DataInputs */

const en_cases_col_claimant_data = /** @type {(inputs: Cases_Col_Claimant_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant`)
};

const pt_br2_cases_col_claimant_data = /** @type {(inputs: Cases_Col_Claimant_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerente`)
};

/**
* | output |
* | --- |
* | "Claimant" |
*
* @param {Cases_Col_Claimant_DataInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_claimant_data = /** @type {((inputs?: Cases_Col_Claimant_DataInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Claimant_DataInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_claimant_data(inputs)
	return pt_br2_cases_col_claimant_data(inputs)
});